import './navigation';
import './accordion';
import './slider';
import './marquee';
import './video';
import './post-teasers-loader';
import './people-filter';

(function ($) {
	$('h1').wrapInner('<span>');

})(jQuery);
